__turbopack_context__.v({
  "backgroundImage": "intro-module-scss-module__wf-Rda__backgroundImage",
  "intro": "intro-module-scss-module__wf-Rda__intro",
  "introContainer": "intro-module-scss-module__wf-Rda__introContainer",
  "introDescription": "intro-module-scss-module__wf-Rda__introDescription",
  "introTitle": "intro-module-scss-module__wf-Rda__introTitle",
});
